module.exports = __webpack_public_path__ + "img/people.09847269.png";